"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SortableTableHeader;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tooltip = _interopRequireDefault(require("./tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StyledButton = _styledComponents.default.button`
  border: none;
  background: none;
  text-align: inherit;
  padding: 0.3rem;
  min-width: 2.7em;
  &:focus {
    outline: none;
  }
`;
const StyledTH = _styledComponents.default.th`
  padding: 0 !important;
  &:hover {
    background: #eae9e9;
  }
`;
function getDirectionArrow(direction) {
  if (direction === 'ASC') return '▾';
  if (direction === 'DESC') return '▴';
  return ' ';
}
function SortableTableHeader(props) {
  return /*#__PURE__*/_react.default.createElement(_tooltip.default, {
    placement: "top",
    overlay: props.title || props.overlay || 'Click to Sort'
  }, /*#__PURE__*/_react.default.createElement(StyledTH, {
    className: props.className
  }, /*#__PURE__*/_react.default.createElement(StyledButton, {
    onClick: () => props.onClick(props.columnID),
    style: props.style
  }, props.children, props.columnID !== props.sortedColumnID ? '' : getDirectionArrow(props.sortedDirection))));
}